var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('df-nav',{attrs:{"user":_vm.user || {},"website":_vm.labUrl,"language":this.$i18n.locale,"config":_vm.navConfig,"show-message":false,"theme":_vm.theme},on:{"language":_vm.switchLang,"command":_vm.handleUserOperate}})}
var staticRenderFns = []

export { render, staticRenderFns }